import React, {useState, useEffect, useContext, useCallback, useRef} from 'react';
import GridLayout from 'react-grid-layout';
import './gridcomponents/css/SuperStarInstrumentGrid.css';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import SuperStarInstrumentRow from "./gridcomponents/SuperStarInstrumentrow/SuperStarInstrumentRow";

import {fetchSuperStarInstruments} from './SuperStarInstrumentService';
import ActionButtons from "../superstar/gridcomponents/components/ActionButtons";
import {useStateUpdatePermission} from "../contexts/StateUpdateContext";
import WebSocketService from "../../websockets/WebSocketService";
import {handleSearch, updateTickerSubscriptionWithKite} from "../services/apiService";
import {handleShowDetails} from "./gridcomponents/SuperStarInstrumentrow/MoreDetails/MoreDetailsOperations";
import {TickProvider} from "../contexts/TickContext";
import SearchBar from './gridcomponents/components/SearchBar';
import { InstrumentRowContext } from "@dashboard/contexts/InstrumentRowContext";

const SuperStarInstrumentsGrid = () => {
    const [SuperStarInstruments, setSuperStarInstruments] = useState([]);
    const [layouts, setLayouts] = useState([]);
    const [newRowAdded, setNewRowAdded] = useState(false);
    const [filteredInstruments, setFilteredInstruments] = useState([]);
    const [sortDirection, setSortDirection] = useState('asc'); // State for sort direction
    const [draggingItem, setDraggingItem] = useState(null);
    const {canUpdateState, setCanUpdateState} = useStateUpdatePermission(); // Access state and setter
    const gridLayoutRef = useRef(null);
    const moreDetailsLayoutRef = useRef(null); // Define the ref in a React component
    const rowHeightGridLayout = 45;
    const [sSGrefreshKey, setSSGRefreshKey] = useState(0);
    const [searchQuery, setSearchQuery] = useState('');
    const [isCircleGreen, setIsCircleGreen] = useState(true); // State to hold circle color
    const [pendingRefresh, setPendingRefresh] = useState(false); // Track if a refresh is pending
    const tabID = 9;
    const [superStarNameMap, setSuperStarNameMap] = useState({});  // Store superStarNameMap in state
    const [superStarInstrumentsOneQtr, setSuperStarInstrumentsOneQtr] = useState([]);
    const [loading, setLoading] = useState(true);

    let startX, startY;
    // Function to toggle the circle color and handle custom code
    /*    const handleCircleToggle = (SuperStarInstruments, setSuperStarInstruments, setLayouts, tabID) => {

            // Placeholder for custom code when the color changes
            console.log(`Custom code executed for instrumentToken: ${instrumentToken}`);
        };*/

    /*   useEffect(() => {
           handleSearch(searchQuery, allInstrumentsList, setFilteredInstruments);
       }, [searchQuery]);*/

    // Function to update price difference for each instrument
    const handlePriceDifferenceUpdate = (instrumentToken, priceDifference) => {
       /* if (canUpdateState) {
            setSuperStarInstruments((prevInstruments) =>
                prevInstruments.map(instrument => {
                    if (instrument.instrumentEntity.instrumentToken === instrumentToken) {
                        return {...instrument, priceDifferencePercentage: priceDifference};
                    }
                    return instrument;
                })
            );
        }*/
    }
    const processSuperStarNames = (superStarInstruments) => {
        const uniqueSuperStarNames = new Set();

        superStarInstruments.forEach((instrument) => {
            instrument.superStarHoldingsList.forEach((holding) => {
                uniqueSuperStarNames.add(holding.superStarName);
            });
        });

        const map = {};
        uniqueSuperStarNames.forEach((superStarName) => {
            const trimmedSuperStarName = superStarName.trim();
            const shortenedName = trimmedSuperStarName
                .split(' ')
                .filter(word => word.length > 0)
                .map(word => word[0].toUpperCase())
                .join('');

            map[superStarName] = shortenedName;
        });

        return map;
    };

    const parseQuarterDate = (qtr) => {
        const [monthStr, yearStr] = qtr.split(' ');
        const months = {
            Jan: 0,
            Feb: 1,
            Mar: 2,
            Apr: 3,
            May: 4,
            Jun: 5,
            Jul: 6,
            Aug: 7,
            Sep: 8,
            Oct: 9,
            Nov: 10,
            Dec: 11
        };
        const month = months[monthStr];
        const year = parseInt(yearStr, 10);
        return new Date(year, month);
    };

    // Function to process superStarInstruments and retain only the latest quarter in holdingLst
    const processSuperStarInstrumentsForLatestQtr = (superStarInstruments) => {
        return superStarInstruments.map(instrument => {
            const updatedHoldingsList = instrument.superStarHoldingsList.map(holding => {
                // Find the latest quarter in holding.holdingLst
                const latestHolding = holding.holdingLst.reduce((latest, current) => {
                    return parseQuarterDate(current.qtr) > parseQuarterDate(latest.qtr) ? current : latest;
                });

                // Return the holding with the latest qtr
                return {
                    ...holding,
                    holdingLst: [latestHolding]  // Keep only the latest quarter in holdingLst
                };
            });

            // Return the updated instrument with modified superStarHoldingsList
            return {
                ...instrument,
                superStarHoldingsList: updatedHoldingsList  // Update superStarHoldingsList with the latest quarter
            };
        });
    };

    useEffect(() => {
        setLoading(true); // Start loading
        fetchSuperStarInstruments().then(data => {
            console.log('In fetchSuperStarInstruments');
            if (data.length !== (SuperStarInstruments?.length || 0)) {
                const updatedSuperStarNameMap = processSuperStarNames(data);
                setSuperStarNameMap(updatedSuperStarNameMap);
                const updatedSuperStarInstrumentsForLatestQtr = processSuperStarInstrumentsForLatestQtr(data);
                setSuperStarInstrumentsOneQtr(updatedSuperStarInstrumentsForLatestQtr);
            }
            setSuperStarInstruments(data);

            const initialLayouts = data.map((SuperStarInstrument, index) => ({
                i: `${tabID}-${SuperStarInstrument.instrumentEntity.instrumentToken}`,
                x: 0,
                y: index,
                w: 12,
                h: 1,
            }));
            setLayouts(initialLayouts);

            const instrumentEntities = data.map(SuperStarInstrument => SuperStarInstrument.instrumentEntity);

            updateTickerSubscriptionWithKite(instrumentEntities, tabID)
                .catch(error => console.error('Error in subscription with Kite:', error));
        }).finally(() => {
            setLoading(false); // ✅ Stop loading regardless of success/failure
        });
    }, [sSGrefreshKey]);

    useEffect(() => {
        /*handleSearch(searchQuery, allInstrumentsList, setFilteredInstruments);*/
        handleSearch(searchQuery, null, setFilteredInstruments);
    }, [searchQuery]);

    const handleEscape = (event) => {
        if (event.key === 'Escape') {
            setSearchQuery('');
        }
    };

    const isCircleGreenRef = useRef(isCircleGreen);
    useEffect(() => {
        const refreshSuperStar_Grid = () => {
            console.log(`Received WebSocket message to refresh the grid`);

            // Check the current color of the circle using the ref
            /*if (isCircleGreenRef.current) {
                console.log(`Circle is green, refreshing the grid immediately`);
                setSSGRefreshKey(oldSSGrefreshKey => oldSSGrefreshKey + 1); // Refresh immediately
            } else {
                console.log(`Circle is red, waiting for it to turn green before refreshing`);
                setPendingRefresh(true); // Set refresh as pending until circle turns green
            }*/
        };

        // Subscribe to the WebSocket service only once
        WebSocketService.subscribe('reloadSSG', null, refreshSuperStar_Grid);

        // Cleanup WebSocket subscription on component unmount
        return () => {
            console.log(`Unsubscribing from WebSocket for reloadSSG`);
            WebSocketService.unsubscribe('reloadSSG', null, refreshSuperStar_Grid);
        };
    }, []);  // Empty dependency array ensures subscription happens only once

    useEffect(() => {
        if (isCircleGreen && pendingRefresh) {
            console.log(`Circle turned green, performing pending grid refresh`);
            setSSGRefreshKey(oldSSGrefreshKey => oldSSGrefreshKey + 1); // Trigger the pending grid refresh
            setPendingRefresh(false); // Reset pending refresh state
        }
    }, [isCircleGreen, pendingRefresh]);
    // Function to toggle the circle color and update the ref
    const handleCircleToggle = () => {
        setIsCircleGreen(prevState => {
            const newState = !prevState;
            isCircleGreenRef.current = newState;  // Update the ref
            return newState;
        });
        console.log("Toggling color...");

    };
    useEffect(() => {
        // Update the ref whenever isCircleGreen changes
        isCircleGreenRef.current = isCircleGreen;
    }, [isCircleGreen]);
    useEffect(() => {
        //console.log("isCircleGreen: ", isCircleGreen);
    }, [isCircleGreen]);
    // Dynamically calculate rowHeight and total grid height
    const rowHeightNewGridLayout = 36; // Assume each row is 40px high

    return (
        <>
            {loading ? (
                <div className="pf-loading-wrapper">
                    <div className="pf-spinner"/>
                    <div className="pf-loading-text">Loading…</div>
                </div>
            ) : (
                <div className="grid-wrapper">
                    <div className="grid-container">
                        <div className={'superstar-grid-holder'} key={tabID}>
                            <div className="resizable-container">
                                <div className="overlaping-grid-container">
                                    <SearchBar
                                        searchQuery={searchQuery}
                                        setSearchQuery={setSearchQuery}
                                        isCircleGreen={isCircleGreen}
                                        handleCircleToggle={handleCircleToggle}
                                    />
                                </div>

                                {/* Old Grid Layout */}
                                <div ref={gridLayoutRef} className="grid-layout-wrapper">
                                    <GridLayout
                                        className="grid-layout"
                                        layout={layouts}  // Layout prop controlling item positions
                                        cols={1}
                                        rowHeight={rowHeightGridLayout}
                                        width="400"
                                        isResizable={false}
                                        isDraggable={true}
                                        margin={[0, 0]}
                                        containerPadding={[0, 0]}
                                        draggableCancel=".symbol_n_exchange, .actionsSS, .actionsSS *"
                                    >
                                        {layouts
                                            .map((layout, index) => {
                                                /*console.log("layout index:",index);*/
                                                /*console.log("layout.i:",layout.i);*/
                                                /*console.log("SuperStarInstruments",SuperStarInstruments);*/
                                                const instrument = SuperStarInstruments.find(
                                                    (instrument) => `${tabID}-${instrument.instrumentEntity.instrumentToken}` === layout.i
                                                );
                                                /*const instrument = SuperStarInstruments.find(
                                                    (instrument) => `${instrument.sequenceNumber}` === layout.y
                                                );*/
                                                return (
                                                    <div
                                                        key={layout.i}
                                                        className="grid-item"
                                                    >
                                                        {(() => {
                                                            /*console.log("Layout ID:", layout.y);
                                                            console.log("Instrument:", instrument);*/
                                                        })()}
                                                        {instrument ? (
                                                            <SuperStarInstrumentRow
                                                                SuperStarInstrument={instrument}
                                                                uniqueId={layout.i}
                                                                onPriceDifferenceUpdate={handlePriceDifferenceUpdate} // Pass the callback
                                                                setLayouts={setLayouts}
                                                                layoutIndex={index}
                                                                superStarNameMap={superStarNameMap}
                                                                oneQtrInstrument={
                                                                    superStarInstrumentsOneQtr.find(
                                                                        oneQtrInstrument => oneQtrInstrument.instrumentEntity.tradingsymbol === instrument.instrumentEntity.tradingsymbol
                                                                    )
                                                                }
                                                                tabID={tabID}
                                                                setSuperStarInstruments={setSuperStarInstruments}
                                                            />

                                                        ) : (
                                                            <div>No Instrument Found</div>
                                                        )}
                                                    <InstrumentRowContext.Provider
                                                    value={{
                                                    uniqueId: layout.i,
                                                    GUIInstrument: instrument,
                                                    setGUIInstruments: setSuperStarInstruments,
                                                    setLayouts,
                                                    tabID,
                                                    layouts,
                                                    index,
                                                    layoutIndex: index,
                                                    ROW_HEIGHT: rowHeightGridLayout
                                                        }}
                                                    >
                                                        <TickProvider
                                                            instrumentToken={instrument.instrumentEntity.instrumentToken}>
                                                            <ActionButtons
                                                                instrumentToken={instrument.instrumentEntity.instrumentToken}
                                                                SuperStarInstrument={instrument}
                                                                setSuperStarInstruments={setSuperStarInstruments}
                                                                setLayouts={setLayouts}
                                                                tabID={tabID}
                                                                onShowDetails={() => handleShowDetails(instrument.instrumentEntity.instrumentToken, SuperStarInstruments, setSuperStarInstruments, setLayouts, tabID, index, moreDetailsLayoutRef)}
                                                                layouts={layouts}
                                                            />
                                                        </TickProvider>
                                                    </InstrumentRowContext.Provider>
                                                    </div>
                                                );
                                            })}
                                    </GridLayout>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            )}
        </>
    );
}

    export default SuperStarInstrumentsGrid;
